import { render, staticRenderFns } from "./ActionListSettings.vue?vue&type=template&id=2c148687&"
import script from "./ActionListSettings.vue?vue&type=script&lang=ts&"
export * from "./ActionListSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports